var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5742 2.63672L8.41797 7.79297L13.5312 12.9062C13.9609 13.293 13.9609 13.9375 13.5312 14.3242C13.1445 14.7539 12.5 14.7539 12.1133 14.3242L6.95703 9.21094L1.84375 14.3242C1.45703 14.7539 0.8125 14.7539 0.425781 14.3242C-0.00390625 13.9375 -0.00390625 13.293 0.425781 12.8633L5.53906 7.75L0.425781 2.63672C-0.00390625 2.25 -0.00390625 1.60547 0.425781 1.17578C0.8125 0.789062 1.45703 0.789062 1.88672 1.17578L7 6.33203L12.1133 1.21875C12.5 0.789062 13.1445 0.789062 13.5742 1.21875C13.9609 1.60547 13.9609 2.25 13.5742 2.63672Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconDark);
export default __webpack_public_path__ + "static/media/close_icon_dark.38f845132442ec5f5f88777eb91bef48.svg";
export { ForwardRef as ReactComponent };